export default "__VITE_ASSET__1c45f9c9__"